(function () {
  const FORMATTED_CLASS = 'installment-formatted-text';
  const HIDDEN_CLASS = 'installment-line-break-hidden';
  const PROCESSED_ATTR = 'data-installment-break';

  function escapeHtml(value) {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeText(value) {
    return value.replace(/\s+/g, ' ').trim();
  }

  function splitOnFirstComma(text) {
    const commaIndex = text.indexOf(',');

    if (commaIndex === -1) return null;

    const before = text.slice(0, commaIndex + 1);
    const after = text.slice(commaIndex + 1).trim();

    if (!after) return null;

    return { before, after };
  }

  function getTermsText(element) {
    return normalizeText(element.innerText || element.textContent || '');
  }

  function ensureMirror(form) {
    let mirror = form.querySelector(`.${FORMATTED_CLASS}`);

    if (!mirror) {
      mirror = document.createElement('div');
      mirror.className = FORMATTED_CLASS;
      form.insertBefore(mirror, form.querySelector('shopify-payment-terms'));
    }

    return mirror;
  }

  function updateMirror(element, parts) {
    const form = element.closest('form.installment');
    if (!form || !parts) return false;

    const mirror = ensureMirror(form);
    mirror.innerHTML = `<span>${escapeHtml(parts.before)}</span><br><span>${escapeHtml(parts.after)}</span>`;
    element.classList.add(HIDDEN_CLASS);
    element.setAttribute(PROCESSED_ATTR, parts.before + parts.after);
    return true;
  }

  function processElement(element) {
    const text = getTermsText(element);
    const parts = splitOnFirstComma(text);

    if (!parts) {
      element.classList.remove(HIDDEN_CLASS);
      element.removeAttribute(PROCESSED_ATTR);
      element.closest('form.installment')?.querySelector(`.${FORMATTED_CLASS}`)?.remove();
      return;
    }

    const signature = parts.before + parts.after;
    if (element.getAttribute(PROCESSED_ATTR) === signature) return;

    updateMirror(element, parts);
  }

  function processInstallments(scope = document) {
    scope.querySelectorAll('form.installment shopify-payment-terms').forEach(processElement);
  }

  function watchInstallments(scope = document) {
    processInstallments(scope);

    [50, 150, 400, 900, 1800, 3500, 6000].forEach((delay) => {
      window.setTimeout(() => processInstallments(scope), delay);
    });

    scope.querySelectorAll('form.installment').forEach((form) => {
      if (form.dataset.installmentWatch === 'true') return;

      form.dataset.installmentWatch = 'true';

      const observer = new MutationObserver(() => processInstallments(form));
      observer.observe(form, { childList: true, subtree: true, characterData: true });
    });
  }

  function init() {
    watchInstallments();
    customElements.whenDefined('shopify-payment-terms').then(() => watchInstallments());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('product-info:loaded', (event) => {
    watchInstallments(event.target);
  });
})();
